import { Link, Outlet, useNavigate } from "react-router-dom";
import { StaticImage } from "../utils/image";
import { LogoutIcon, MenuIcon } from '@heroicons/react/outline'
import { useDispatch, useSelector } from "react-redux";
import { removeLocalStorage, setLocalStorage } from "../utils/localStorage";
import { Menu } from '@headlessui/react'
import { useState } from "react";
import Modal from "./Modal";
import CSwl from "../utils/alert";
import ApiUser from "../api/ApiUser";
import ModalNoButton from "./ModalNoButton";
import Swal from "sweetalert2";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
} from "@azure/msal-react";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from "./LanguageSwitcher";

const Layout = () => {
    const { t } = useTranslation();
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userState = useSelector((state) => state.user);
    const adminLogin = useSelector((state) => state.adminLogin);
    const isQA = useSelector((state) => state.isQA);
    const whExport = useSelector((state) => state.whExport);
    const adminEmail = useSelector((state) => state.email);
    const adminOfficerCode = useSelector((state) => state.officerCode);

    const [isChangePassword, setisChangePassword] = useState(false);

    const [state, setstate] = useState({
        password: "",
        confirmPassword: "",
        newPassword: "",
    });

    const logOut = () => {
        if (isAuthenticated) {
            handleLogout(instance);
        } else {
            Swal.showLoading();
            localStorage.clear();
            sessionStorage.clear();
            setLocalStorage("token", "");
            dispatch({ type: "clear_all" });
            setTimeout(() => {
                Swal.close();
                navigate("/login", { replace: true })
            }, 2000);
        }
    };


    function handleLogout(instance) {
        sessionStorage.clear();
        localStorage.clear();
        setLocalStorage("token", "");
        dispatch({ type: "clear_all" });
        instance.logoutRedirect().catch((e) => {
            setTimeout(() => {
                navigate("/login", { replace: true })
            }, 2000);
        });
    }

    const changePassword = async (e) => {
        e.preventDefault();
        CSwl.SwalLoad();
        if (state.newPassword !== state.confirmPassword) {
            setstate({ ...state, messageError: t('login.confirmPasswordMismatch') });
            CSwl.SwalClose();
            return false;
        }
        const response = await ApiUser.changePassword({
            "officer_code": userState.officerCode,
            "oldPassword": state.password,
            "newPassword": state.newPassword,
        });
        if (response.status == 200) {
            const swal = await CSwl.SwalSuccess(t('layout.changePasswordSuccess'), { html: t('layout.changePasswordSuccess') });
            if (swal.isConfirmed) {
                setisChangePassword(false);
            }
        } else {
            CSwl.SwalClose();
            setstate({ ...state, messageError: response.data });
        }

    }


    return <>
        <div className="w-full bg-white py-2 px-4 shadow-slate-200 shadow-md flex items-center justify-between fixed top-0 z-10">
            <img className="object-contain h-16 w-24" src={StaticImage('/images/logoSCGPSolidBlac-removebg-preview.png')} />
            <div className="flex items-center relative">
                <LanguageSwitcher className="mr-2" />
                <span>{userState.email}</span>
                <Menu>
                    {({ open }) => (
                        <>
                            <Menu.Button>
                                <MenuIcon className="h-5 w-5 text-black ml-2" />
                            </Menu.Button>
                            {open && (
                                <div className="menu-container border border-gray-200">
                                    <Menu.Items>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <div onClick={() => navigate('/profile')} className="flex gap-x-2">
                                                    <span>{t('layout.profile')}</span>
                                                </div>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <div onClick={() => setisChangePassword(true)} className="flex gap-x-2">

                                                    <span>{t('layout.changePassword')}</span>
                                                </div>
                                            )}
                                        </Menu.Item>
                                        {
                                            whExport &&
                                            <>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <div onClick={() => {
                                                            window.location.href = process.env.REACT_APP_URL_BACKEND + `#/login?username=${adminOfficerCode}`
                                                        }} className="flex gap-x-2">

                                                            <span>{t('layout.enterEdn')}</span>
                                                        </div>
                                                    )}
                                                </Menu.Item>
                                            </>
                                        }
                                        {
                                            adminLogin &&
                                            <>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <div onClick={() => {
                                                            window.location.href = window.location.origin + `/login?username=${adminEmail}&officer_code=${adminOfficerCode}`

                                                        }} className="flex gap-x-2">

                                                            <span>{t('layout.backToSelectTruck')}</span>
                                                        </div>
                                                    )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <div onClick={() => {
                                                            window.location.href = process.env.REACT_APP_URL_BACKEND + `#/login?username=${adminOfficerCode}`
                                                        }} className="flex gap-x-2">

                                                            <span>{t('layout.enterEdn')}</span>
                                                        </div>
                                                    )}
                                                </Menu.Item>
                                            </>
                                        }

                                        {
                                            isQA &&
                                            <>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <div onClick={() => {
                                                            window.location.href = process.env.REACT_APP_URL_BACKEND + `#/login?username=${userState.officerCode}`
                                                        }} className="flex gap-x-2">

                                                            <span>{t('layout.enterEdn')}</span>
                                                        </div>
                                                    )}
                                                </Menu.Item>
                                            </>
                                        }

                                        <Menu.Item>
                                            {({ active }) => (
                                                <div onClick={() => logOut()} className="flex gap-x-2">

                                                    <span>{t('layout.logout')}</span>
                                                </div>
                                            )}
                                        </Menu.Item>
                                    </Menu.Items>
                                </div>
                            )}
                        </>
                    )}
                </Menu>
            </div>
        </div>
        <section className="min-h-screen pt-80px">
            <ModalNoButton isModal={isChangePassword} onClose={() => setisChangePassword(false)}>
                <form onSubmit={changePassword}>
                    <div className="bg-white rounded flex flex-col items-center">
                        <div>
                            <h1 className="font-bold text-3xl">{t('login.changePassword')}</h1>
                        </div>
                        <input value={state.password}
                            onChange={(e) => {
                                setstate({ ...state, password: e.target.value })
                            }} required className="form-control w-72 mt-1" placeholder="Password" type="password" />
                        <input value={state.newPassword}
                            onChange={(e) => {
                                setstate({ ...state, newPassword: e.target.value })
                            }} required className={`${state.showLogin ? "hidden" : ""} form-control w-72 mt-1`} placeholder="New Password" type="password" />
                        <input value={state.confirmPassword}
                            onChange={(e) => {
                                setstate({ ...state, confirmPassword: e.target.value })
                            }} required className={`${state.showLogin ? "hidden" : ""} form-control w-72 mt-1`} placeholder="Confirm Password" type="password" />
                        {state.messageError && <label className="text-red">{state.messageError}</label>}
                        <div className="flex gap-x-2 w-full">
                            <button type="button" onClick={() => setisChangePassword(false)} className="btn-gray flex-1 mt-2">{t('common.cancel')}</button>
                            <button type="submit" className="btn-red flex-1 mt-2">{t('login.changePassword')}</button>
                        </div>

                    </div>
                </form>
            </ModalNoButton>
            <Outlet />
        </section>
    </>
}

export default Layout;
